import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';

type SaveSharedPlannedWorkoutInput = {
  token: string;
  plannedDate: string;
};

type SavedPlannedWorkout = {
  id: number;
};

export const useSaveSharedPlannedWorkout = () => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      token,
      plannedDate,
    }: SaveSharedPlannedWorkoutInput) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/shared/planned-workouts/${encodeURIComponent(token)}/save`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${await getAccessTokenSilently()}`,
          },
          body: JSON.stringify({ planned_date: plannedDate }),
        },
      );

      if (!response.ok) {
        throw new Error('Unable to save this workout');
      }

      return (await response.json()).workout as SavedPlannedWorkout;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['plannedWorkouts'] }),
  });
};
